import { render } from "./BlckDocumentUpdatedPopup.vue?vue&type=template&id=063d69b5&scoped=true"
import script from "./BlckDocumentUpdatedPopup.vue?vue&type=script&lang=js"
export * from "./BlckDocumentUpdatedPopup.vue?vue&type=script&lang=js"

import "./BlckDocumentUpdatedPopup.vue?vue&type=style&index=0&id=063d69b5&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063d69b5"]])

export default __exports__